import { Action } from "redux";

import {
  GET_RESPONSE_DETAILS_BY_ID,
  GET_REQUEST_DETAILS_BY_ID,
  IS_LOADING,
  IS_SENT,
} from "./types";

interface RequestDetailsAction extends Action {
  payload: any;
}

const initialState = {
  requestDetails: null,
  responseDetails: null,
  loading: false,
  isSent: false,
};

export default (state = initialState, action: RequestDetailsAction) => {
  switch (action.type) {
    case GET_REQUEST_DETAILS_BY_ID:
      return {
        ...state,
        requestDetails: action.payload,
      };
    case GET_RESPONSE_DETAILS_BY_ID:
      return {
        ...state,
        responseDetails: action.payload,
      };
    case IS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case IS_SENT:
      return {
        ...state,
        isSent: action.payload,
      };
    default:
      return state;
  }
};
